/* ================================================== */
/* CHECK BREAKPOINTS
/* ================================================== */

// Init
var breakpointLg, breakpointMd, breakpointSm, breakpointXs;

// Check breakpoints
function checkBreakpoints() {
	breakpointLg = $(window).width() >= 1225;
	breakpointMd = $(window).width() >= 1025 && $(window).width() <= 1224;
	breakpointSm = $(window).width() >= 705 && $(window).width() <= 1024;
	breakpointXs = $(window).width() < 705;
}

$(document).ready(checkBreakpoints());
$(window).on('resize orientationchange', function() {
	checkBreakpoints()
});